import type { ImageOverlay, Layer } from 'leaflet';
import { imageOverlay } from 'leaflet';
import { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';

import { useAppState } from '@/overmind';

import { useShouldGridImageBeVisible } from './useShouldGridImageBeVisible';

function useOldLayerUntilNewIsLoaded(newLayer: Layer | undefined) {
  const showLayer = useShouldGridImageBeVisible();
  const map = useMap();
  const [mapLayer, setMapLayer] = useState<Layer>();
  useEffect(() => {
    if (map) {
      const mapHasOldLayer = mapLayer && map.hasLayer(mapLayer);
      if (showLayer && newLayer) {
        if (mapHasOldLayer) {
          // remove old layer once the new layer is loaded
          newLayer.once('load', () => map.removeLayer(mapLayer));
        }
        map.addLayer(newLayer);
      } else if (mapHasOldLayer) {
        map.removeLayer(mapLayer);
      }
      setMapLayer(newLayer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, newLayer, showLayer]);
}

// function useCachedMapImage(map: Map | null, show: boolean) {
function useLatestLoadedGridImage() {
  const [mapLayer, setMapLayer] = useState<ImageOverlay>();
  const state = useAppState().arcgis.mapImage;

  useEffect(() => {
    if (state.current === 'LOADED') {
      setMapLayer(imageOverlay(state.value.href, state.value.bounds));
    } else if (state.current !== 'LOADING') {
      setMapLayer(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.current]);

  return mapLayer;
}

export function useGridImageWithTransition() {
  const mapLayer = useLatestLoadedGridImage();
  useOldLayerUntilNewIsLoaded(mapLayer);
}
